import type { StagingDiversion } from "./SystemSettingsStagingDiversion.types";

/** Diversion targets, in display order. A null value means unchecked. */
export const STAGING_DIVERSION_TARGETS = [
  {
    key: "catalog",
    label: "Catalog",
    description: "Existing catalog to write every output table into.",
    placeholder: "staging_catalog",
  },
  {
    key: "database_suffix",
    label: "Database suffix",
    description: "Added to the database name of every output table.",
    placeholder: "_staging",
  },
  {
    key: "table_suffix",
    label: "Table suffix",
    description: "Added to the name of every output table.",
    placeholder: "_staging",
  },
] as const satisfies readonly {
  key: keyof StagingDiversion;
  label: string;
  description: string;
  placeholder: string;
}[];
